import { useSessionStore } from '@/src/hooks/use_session_store'

export const useIsInsightsAdmin = (): boolean => {
  const session = useSessionStore()
  return session.user?.isInsightsAdmin === true
}
